import { useState, useRef } from "react";
import api from "@/services/api/approvals";
import { orderBy } from "lodash";
import KeyHelper from '@/utils/key-helper';


const useApprovalsPage = () => {

	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]);
	const [errorMsg, setErrorMsg] = useState();
	const [meta, setMeta] = useState({});
	const [sortConfig, setSortConfig] = useState({ sortBy: 'modified', direction: false })
	const [currentItem, setCurrentItem] = useState(null);

	const lastRequestPayloadKeyRef = useRef(null)

	async function fetchApprovals(parameter) {
		const currentPayloadKey = KeyHelper.createKeyOfObject({ parameter })

		if(KeyHelper.isSameKey(lastRequestPayloadKeyRef.current, currentPayloadKey)) return;

		lastRequestPayloadKeyRef.current = currentPayloadKey

		setLoading(true);

		const params = parameter ? parameter : "";
		const [error, response] = await api.index({ params });

		setLoading(false);

		if (error) {
			return setErrorMsg(error);
		}

		const { items, meta } = response;

		if (!Array.isArray(items)) {
			return setErrorMsg("Approvals is not an array");
		}
		const sortedProvideItems = orderBy(items, [sortConfig.sortBy], [sortConfig.direction ? 'asc' : 'desc']);

		setMeta(meta);
		setData(sortedProvideItems);
	}

	async function fetchOne(id) {
		setLoading(true);

		const [error, response] = await api.findOne(id);

		if (error) {
			setLoading(false);
			return setErrorMsg(error);
		}

		setLoading(false);
		setCurrentItem(response);
	}

	return {
		fetchApprovals,
		loading,
		setLoading,
		errorMsg,
		data,
		meta,
		itemsData: data,
		currentItem,
		fetchOne,
		setData,
		sortConfig,
		setSortConfig,
	};
};
export default useApprovalsPage;
